export enum Socialtype {
  facebook = 'facebook',
  google = 'google'
}
